import React from 'react'

import type { CmsIcon } from '@flows/index'
import PhosphorIcon from '@ui-kit/components/PhosphorIcon'
import type { PhosphorIconProps } from '@ui-kit/components/PhosphorIcon'

export const CoverageCmsIcon = ({ icon }: { icon?: CmsIcon }) => {
  if (!icon?.name) {
    return null
  }

  return (
    <PhosphorIcon
      name={icon.name as PhosphorIconProps['name']}
      size={icon.size ?? 24}
      weight={icon.weight as PhosphorIconProps['weight']}
    />
  )
}
